<template>
  <v-container>
    <v-breadcrumbs :items="crumbs"
      ><template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template></v-breadcrumbs
    >
    <v-card v-if="!loading">
      <v-card-title
        :style="{
          background: status === 'active' ? 'lightgreen' : 'none',
          'padding-bottom': '4px',
          'padding-top': '11px',
          'border-bottom': '1px solid #ddd'
        }"
      >
        <v-row no-gutters
          ><v-col cols="10"><VoteStatus /><PollDisplayOptions /></v-col
          ><v-col class="text-right pt-4" cols="2"
            ><Stopwatch :pollId="livePoll._id"/></v-col
        ></v-row>
      </v-card-title>

      <v-card-title style="word-break: normal;">
        {{ livePoll.pollText }}</v-card-title
      >
      <v-card-text>
        <!-- POLL IS IN PROGRESS DISPLAY CLOSE BUTTON-->
        <div v-if="status === 'active'">
          <v-btn
            @click="closePoll(livePoll)"
            :loading="loadingPoll"
            dark
            color="red"
            >Close Poll</v-btn
          >
        </div>

        <!-- POLL HAS BEEN CLOSED SHOW RESULTS BUTTON -->
        <div v-else-if="status === 'results'">
          <v-btn
            @click="closeResults(livePoll)"
            :loading="loadingPoll"
            color="primary"
            dark
            >Close Results</v-btn
          >
          <span v-if="livePoll.showResults" class="poll-in-progress"
            >RESULTS ARE BEING DISPLAYED</span
          >
          <span v-if="!livePoll.showResults" class="poll-in-progress"
            >RESULTS ARE BEING HIDDEN</span
          >
        </div>

        <!-- WAITING TO LAUNCH A POLL -->
        <div v-else>
          <v-btn
            @click="launchPoll(livePoll)"
            :loading="loadingPoll"
            color="primary"
            dark
            >Launch Poll</v-btn
          >
        </div>

        <div style="margin-top:40px;">
          <VoteResults v-if="livePoll" :poll="livePoll"></VoteResults>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import api from "@/services/api.js";
import VoteResults from "@/components/Charts/VoteResults.vue";
import VoteStatus from "@/components/Widgets/VoteStatus.vue";
import Stopwatch from "@/components/Widgets/Stopwatch.vue";
import PollDisplayOptions from "@/components/Widgets/PollDisplayOptions.vue";
export default {
  name: "AdminLivePoll",
  components: {
    VoteResults,
    VoteStatus,
    Stopwatch,
    PollDisplayOptions
  },
  data: () => ({
    loading: false,
    status: "", // active, results, closed

    loadingPoll: true,
    //pollInProgress: false,
    livePoll: "",
    crumbs: [
      { text: "Home", to: "/admin", exact: true },
      { text: "Polls", to: "/admin/polls" },
      { text: "Launch", disabled: true }
    ]
  }),

  async created() {
    this.loading = true;
    this.livePoll = await api.getPoll(this.$route.params["id"]);
    this.$store.commit("SET_ACTIVE_POLL", this.livePoll);
    this.loadingPoll = false;
    this.status = this.livePoll.active ? "active" : "closed";

    this.$socket.client.on("connect", () => {
      console.log("admin client connected to server");
      this.status = "closed";
      this.loadingPoll = false;
    });
    this.$socket.client.on("disconnect", () => {
      console.log("admin client disconnected from server");
      this.status = "closed";
      this.loadingPoll = false;
    });
    this.loading = false;
  },

  methods: {
    async launchPoll(poll) {
      this.loadingPoll = true;
      //this.$store.commit('SET_ACTIVE_POLL', poll);
      this.$socket.client.emit("OPEN_POLL", poll._id);
      this.status = "active";
      this.loadingPoll = false;
    },
    async closePoll(poll) {
      this.loadingPoll = true;
      //this.$store.commit("SET_ACTIVE_POLL", poll);
      this.$socket.client.emit("CLOSE_POLL", poll._id);
      this.status = "results";
      this.loadingPoll = false;
    },
    async closeResults(poll) {
      this.$socket.client.emit("CLOSE_POLL_RESULTS", poll);
      this.status = "closed";
    },
    getPollId() {
      return this.$route.params["id"];
    }
  }
};
</script>
<style>
h1 {
  padding-bottom: 15px;
}
.poll-in-progress {
  margin-left: 15px;
  padding: 5px;
  font-weight: 400;
}
</style>
